import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid-action-buttons" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "popup-header" }
const _hoisted_5 = { class: "popup-header-main" }
const _hoisted_6 = { class: "popup-header-texts" }
const _hoisted_7 = { class: "popup-header-title" }
const _hoisted_8 = { class: "popup-header-meta" }
const _hoisted_9 = { class: "status-chip status-chip--draft" }
const _hoisted_10 = { class: "popup-body-modern" }
const _hoisted_11 = { class: "footer-fixed footer-modern" }
const _hoisted_12 = { class: "footer-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxStateStoring = _resolveComponent("DxStateStoring")!
  const _component_DxLoadPanel = _resolveComponent("DxLoadPanel")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxButton = _resolveComponent("DxButton")!
  const _component_DxGridToolbarItem = _resolveComponent("DxGridToolbarItem")!
  const _component_DxGridToolbar = _resolveComponent("DxGridToolbar")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_DxRequiredRule = _resolveComponent("DxRequiredRule")!
  const _component_DxSimpleItem = _resolveComponent("DxSimpleItem")!
  const _component_DxForm = _resolveComponent("DxForm")!
  const _component_DxPopup = _resolveComponent("DxPopup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_DxDataGrid, {
      ref: "dataGridRef",
      "data-source": _ctx.dsParametri,
      "key-expr": "Cod",
      "allow-column-reordering": true,
      "allow-column-resizing": true,
      "column-resizing-mode": "nextColumn",
      "show-borders": true,
      "show-row-lines": true,
      "show-column-lines": false,
      "column-auto-width": true,
      class: "grid-border",
      onRowRemoving: _ctx.onRowRemoving
    }, {
      valoareTemplate: _withCtx(({ data }) => [
        _createElementVNode("span", null, _toDisplayString(_ctx.formatValoare(data.data)), 1)
      ]),
      gridButtonsTemplate: _withCtx(({ data }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("i", {
            class: "dx-icon-edit grid-btn-edit",
            title: "Editează",
            onClick: ($event: any) => (_ctx.onEditClick(data.data))
          }, null, 8, _hoisted_2),
          _createElementVNode("i", {
            class: "dx-icon-trash grid-btn-delete",
            title: "Șterge",
            onClick: ($event: any) => (_ctx.confirmDelete(data.data))
          }, null, 8, _hoisted_3)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_DxSelection, { mode: "single" }),
        _createVNode(_component_DxFilterRow, { visible: true }),
        _createVNode(_component_DxPaging, { "page-size": 20 }),
        _createVNode(_component_DxSorting, { mode: "multiple" }),
        _createVNode(_component_DxStateStoring, {
          enabled: true,
          "storage-key": "GridParametriAplicatie"
        }),
        _createVNode(_component_DxLoadPanel, { enabled: true }),
        _createVNode(_component_DxEditing, {
          mode: "cell",
          "allow-updating": false,
          "allow-adding": false,
          "allow-deleting": false
        }),
        _createVNode(_component_DxGridToolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_DxGridToolbarItem, { location: "after" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "plus",
                  type: "success",
                  hint: "Adaugă parametru",
                  onClick: _ctx.onAddClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, { location: "after" }, {
              default: _withCtx(() => [
                _createVNode(_component_DxButton, {
                  icon: "refresh",
                  hint: "Reîncarcă",
                  onClick: _ctx.onRefreshClick
                }, null, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_DxGridToolbarItem, { name: "searchPanel" })
          ]),
          _: 1
        }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          placeholder: "Caută..."
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Cod",
          caption: "Cod"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Tip",
          caption: "Tip",
          "calculate-display-value": _ctx.getTipNume
        }, null, 8, ["calculate-display-value"]),
        _createVNode(_component_DxColumn, {
          "data-field": "Valoare",
          caption: "Valoare",
          width: 250,
          "cell-template": "valoareTemplate",
          "allow-filtering": false,
          "allow-sorting": false
        }),
        _createVNode(_component_DxColumn, {
          width: 110,
          "cell-template": "gridButtonsTemplate",
          caption: "Acțiuni",
          alignment: "center"
        })
      ]),
      _: 1
    }, 8, ["data-source", "onRowRemoving"]),
    _createVNode(_component_DxPopup, {
      visible: _ctx.isModalVisible,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.isModalVisible) = $event)),
      "close-on-outside-click": false,
      "show-close-button": false,
      "show-title": true,
      width: 500,
      height: 300,
      "drag-enabled": true
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: _normalizeClass(["popup-header-icon", _ctx.isEditMode ? 'dx-icon-edit' : 'dx-icon-add'])
            }, null, 2),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.isEditMode ? 'Editare Parametru' : 'Adăugare Parametru'), 1),
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "popup-header-subtitle" }, null, -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.isEditMode ? 'Editare' : 'Nou'), 1)
          ])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_DxForm, {
            ref: "formRef",
            "form-data": _ctx.formData,
            "label-mode": "floating",
            "col-count": 1,
            onFieldDataChanged: _ctx.onFieldDataChanged
          }, {
            default: _withCtx(() => [
              _createVNode(_component_DxSimpleItem, {
                "data-field": "Cod",
                "editor-options": { disabled: _ctx.isEditMode }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxRequiredRule, { message: "Codul este obligatoriu" })
                ]),
                _: 1
              }, 8, ["editor-options"]),
              _createVNode(_component_DxSimpleItem, {
                "data-field": "Tip",
                "editor-type": "dxSelectBox",
                "editor-options": _ctx.tipSelectOptionsForm
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DxRequiredRule, { message: "Tipul este obligatoriu" })
                ]),
                _: 1
              }, 8, ["editor-options"]),
              (_ctx.formData.Tip !== null && _ctx.valoareType === 'bool')
                ? (_openBlock(), _createBlock(_component_DxSimpleItem, {
                    key: 0,
                    "data-field": "Valoare",
                    "editor-type": "dxCheckBox",
                    label: { text: 'Activ' }
                  }))
                : _createCommentVNode("", true),
              (_ctx.formData.Tip !== null && _ctx.valoareType === 'date')
                ? (_openBlock(), _createBlock(_component_DxSimpleItem, {
                    key: 1,
                    "data-field": "Valoare",
                    "editor-type": "dxDateBox",
                    "editor-options": _ctx.dateOptions
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxRequiredRule, { message: "Valoarea este obligatorie" })
                    ]),
                    _: 1
                  }, 8, ["editor-options"]))
                : _createCommentVNode("", true),
              (_ctx.formData.Tip !== null && _ctx.valoareType === 'number')
                ? (_openBlock(), _createBlock(_component_DxSimpleItem, {
                    key: 2,
                    "data-field": "Valoare",
                    "editor-type": "dxNumberBox",
                    "editor-options": _ctx.numberOptions
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxRequiredRule, { message: "Valoarea este obligatorie" })
                    ]),
                    _: 1
                  }, 8, ["editor-options"]))
                : _createCommentVNode("", true),
              (_ctx.formData.Tip !== null && _ctx.valoareType === 'string')
                ? (_openBlock(), _createBlock(_component_DxSimpleItem, {
                    key: 3,
                    "data-field": "Valoare",
                    "editor-type": "dxTextBox",
                    "editor-options": { width: '100%' }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DxRequiredRule, { message: "Valoarea este obligatorie" })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["form-data", "onFieldDataChanged"]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_DxButton, {
                text: "Salvează",
                type: "success",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                onClick: _ctx.onSave
              }, null, 8, ["onClick"]),
              _createVNode(_component_DxButton, {
                text: "Închide",
                type: "danger",
                width: "120",
                height: "32",
                "styling-mode": "outlined",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isModalVisible = false))
              })
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}